import * as React from 'react';
import styled from 'styled-components';

import { media } from '../../styles/media';

interface ModalVideoProps {
  videoSrc: string;
  open: boolean;
  onClose: () => void;
}

// TODO: look into a11y for this modal and the buttons outside of it that control it
const ModalVideo: React.FunctionComponent<ModalVideoProps> = ({
  open,
  onClose,
  videoSrc,
}) => {
  const [active, setActive] = React.useState(false);
  const videoPlayerRef = React.useRef<HTMLVideoElement>(null);
  const modalVideoRef = React.useRef<HTMLDivElement>(null);

  const openModal = () => {
    const html = document.querySelector('html');
    const wrapper = document.querySelector<HTMLDivElement>('.wrapper');
    const navHolder = document.querySelector('.nav--holder');
    const htmlActive = document.querySelector('html.is-scroll-disabled');

    if (!htmlActive) {
      setActive(true);
      videoPlayerRef?.current?.play();
      navHolder?.classList.add('nav-up');
      if (wrapper)
        wrapper.style.top = `-${document.documentElement.scrollTop}px`;
      html?.classList.add('is-scroll-disabled');
      navHolder?.classList.add('nav-up');
    }
  };

  const closeModal = () => {
    const html = document.querySelector('html');
    const wrapper = document.querySelector<HTMLDivElement>('.wrapper');
    const navHolder = document.querySelector('.nav--holder');

    setActive(false);
    html?.classList.remove('is-scroll-disabled');
    const scrollY = wrapper?.style.top;
    if (wrapper) wrapper.style.top = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
    navHolder?.classList.remove('nav-up');
    videoPlayerRef?.current?.pause();
  };

  React.useEffect(() => {
    open ? openModal() : closeModal();
  }, [open]);

  React.useEffect(() => {
    const addVideoPlaying = () =>
      modalVideoRef?.current?.classList.add('video--playing');
    const removeVideoPlaying = () =>
      modalVideoRef?.current?.classList.remove('video--playing');

    videoPlayerRef?.current?.addEventListener('playing', addVideoPlaying);
    videoPlayerRef?.current?.addEventListener('pause', removeVideoPlaying);

    const closeModalOnEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', closeModalOnEscape);

    return () => {
      videoPlayerRef?.current?.removeEventListener('playing', addVideoPlaying);
      videoPlayerRef?.current?.removeEventListener('pause', removeVideoPlaying);
      document.removeEventListener('keydown', closeModalOnEscape);
      closeModal();
    };
  }, []);

  return (
    <Wrapper>
      <div
        ref={modalVideoRef}
        className={`${
          active ? 'is-active' : ''
        } modal modal--video modal--video--hero`}>
        <div className="container absolute left-0 right-0 top-0 z-20 pt-6">
          <div className="grid grid-cols-2 items-center">
            <div>
              <p className="eyebrow color--white mb-0 hidden items-end md:block">
                <svg
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 12 16"
                  width="12px"
                  height="16px"
                  className="me-3 inline-block">
                  <rect
                    className="volume--bar-1"
                    x="10"
                    y="9"
                    fill="color--white"
                    width="2"
                    height="7"
                  />
                  <rect
                    className="volume--bar-2"
                    x="5"
                    fill="color--white"
                    width="2"
                    height="16"
                  />
                  <rect
                    className="volume--bar-3"
                    y="6"
                    fill="color--white"
                    width="2"
                    height="10"
                  />
                </svg>{' '}
                <span>Best Served with Volume</span>
              </p>
            </div>
            <div className="col-start-2 text-end">
              <button
                onClick={onClose}
                className="z-20 inline-block bg-[transparent]">
                <svg
                  width="14"
                  height="14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill="white"
                    d="M1.774 11.265L.612 10.102l9.499-9.5 1.162 1.163z"
                  />
                  <path
                    fill="white"
                    d="M.61 1.765L1.771.603l9.5 9.499-1.163 1.162z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div className="video--holder">
          <video ref={videoPlayerRef} id="video--hero" controls>
            <source src={videoSrc} type="video/mp4" />
          </video>
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  .video--holder {
    height: 0;
    padding-bottom: 56%;
    background: linear-gradient(
      180deg,
      var(--grey-2) 0,
      var(--grey-2) 50%,
      var(--primary) 50%,
      var(--primary) 100%
    );
    video {
      margin-inline-start: 32px;
      object-fit: cover;
    }
    @media ${media.mdUp} {
      padding-bottom: 67%;
    }
    @media ${media.lgUp} {
      height: calc(100vh - 68px);
      min-height: 620px;
      padding-bottom: 0;
      background: none;
      video {
        margin-inline-start: 0;
      }
    }
  }
  .modal {
    background: var(--black);
    .video--holder {
      video {
        bottom: 0;
        margin: auto;
        object-fit: contain;
        height: auto;
        @media ${media.lgUp} {
          object-fit: cover;
          height: 100%;
        }
      }
    }
  }
`;

export default ModalVideo;
